module.exports = require("@jswork/react-sw-update-tips");